export function getRegion(text) {
  const regions = ['C1', 'C2', 'C3', 'C4', 'C5', 'CS', 'R1', 'R3', 'R4'];
  let txt = text.split('§')[0];
  txt = _.replace(_.replace(_.replace(text, '-', '_'), '-', '_'), '/', '_');
  txt = _.replace(_.replace(_.replace(txt, 'C5_IC', 'C5'), 'C1_CS', 'C1'), 'C1_NE', 'C1');
  txt = _.replace(txt, 'C1_ES_', 'C1_');
  txt = _.replace(_.replace(_.replace(txt, 'Oman', 'OM'), 'Kuwait', 'KW'), 'UK', 'GB');
  txt = _.replace(_.replace(_.replace(txt, 'EM (Bahrain)', 'BH'), 'MYNM (KSA)', 'MM'), 'C4_LA', 'C4');
  txt = _.replace(_.replace(_.replace(txt, 'AGMC (Dubai)', 'AE'), 'ADM (Abu Dhabi)', 'AE'), 'DB', 'AE');
  txt = _.replace(txt, 'AFA (Qatar)', 'QA');
  txt = _.replace(txt, 'AKA (Jordan)', 'JO');
  txt = _.replace(txt, 'BHS (Lebanon)', 'LB');
  txt = _.replace(txt, 'Botswana', 'BW');
  txt = _.replace(txt, 'Namibia', 'NA');
  txt = _.replace(txt, 'Swaziland', 'SZ');
  txt = _.replace(txt, 'Moscow', 'RU');
  let candidates = _.remove(_.split(txt, '_'), function(n) { return !_.includes(regions, n); });
  if (candidates.length === 0) {
    return '';
  } else {
    return candidates[candidates.length - 1].toLowerCase();
  }
}

export function getRegions(text) {
  if (text.includes('/')) {
    return text.split('/').map(p => getRegion(p)).filter(c => c.length > 0);
  }
  const code = getRegion(text);
  return code ? [code] : [];
}
